<div class="diagnostic-detail">
  <div class="table-responsive" *ngIf="diagnosticArticles$ | async">
    <div class="table-title-bar">
      <div class="flex-container">
        <h4><span>{{codeDescription}}</span> - {{ '@vehicle' | translate }}: <span class="name">{{vin}}</span></h4>
      </div>
    </div>

    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="flex-container">
          <div class="table-title-bar" [ngSwitch]="this.protocol">
            <div *ngSwitchCase="'J1939'">
              <h5>{{ '@troubleCode' | translate }} - {{ '@protocol' | translate }}: {{this.protocol}} {{ '@source' | translate }}: {{sourceAddress}} SPN: {{faultCode}} FMI: {{failureCode}}</h5>
            </div>
            <div *ngSwitchCase="'J1708'">
              <h5>{{ '@troubleCode' | translate }} - {{ '@protocol' | translate }}: {{this.protocol}} MID:
                {{sourceAddress}} {{(failureMode == 'pid') ? 'PID' : 'SID'}}: {{faultCode}} FMI: {{failureCode}}</h5>
            </div>
            <div *ngSwitchCase="'OBDII'">
              <h5>{{ '@troubleCode' | translate }} - {{ '@obdii' | translate }}: {{this.obdiiCode}}</h5>
            </div>
            <div *ngSwitchDefault>
              <h5>{{ '@troubleCode' | translate }} - {{ '@protocol' | translate }}: {{this.protocol}}: {{'@protocolNotSupported' | translate}}</h5>
            </div>

            <div class="table-title-col-w align-flex-right">

            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="tenant-detail">
      <div class="content-padding" *ngIf="apiMessage.length > 0">
        {{apiMessage}}
      </div>
      <mat-tab-group (selectedTabChange)="onTabChange($event)" animationDuration="50ms" [selectedIndex]="selectedIndex">
        <mat-tab *ngFor="let tab of tabs;">
          <ng-template mat-tab-label preserveContent="true">
            {{ tab.title | translate }}
          </ng-template>
        </mat-tab>
      </mat-tab-group>
      <div class="content">
        <mat-card appearance="outlined">
          <mat-card-content>
            <div class="mat-mdc-card-outlined">
              <ng-container #tabContent><!-- HERE IS WHERE THE TAB CONTENT COMPONENT WILL BE RENDERED --></ng-container>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</div>